import { StandardEvents } from '@shopify/events';

class GPAmazonCTA extends HTMLElement {
  #section;
  #productUrl = '';
  #variantUrls = {};

  connectedCallback() {
    this.#readData();
    this.#section = this.closest('.shopify-section');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#update(this.dataset.selectedVariantId || '');
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  #readData() {
    const dataElement = this.querySelector('script[type="application/json"]');
    if (!dataElement?.textContent) return;

    try {
      const data = JSON.parse(dataElement.textContent);
      this.#productUrl = typeof data.productUrl === 'string' ? data.productUrl : '';
      this.#variantUrls = data.variants && typeof data.variants === 'object' ? data.variants : {};
    } catch (error) {
      console.warn('[gp-amazon-cta] Invalid variant URL data.', error);
    }
  }

  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const immediateVariantId = event.detail?.variantId;
    if (typeof immediateVariantId === 'string') this.#update(immediateVariantId);

    event.promise
      ?.then(({ detail }) => {
        if (detail?.productId && String(detail.productId) !== this.dataset.productId) return;
        const resolvedVariantId = detail?.resource?.id;
        this.#update(resolvedVariantId == null ? immediateVariantId || '' : String(resolvedVariantId));
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[gp-amazon-cta] Variant update failed.', error);
      });
  };

  #update(variantId) {
    const link = this.querySelector('[ref="link"]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const variantUrl = typeof this.#variantUrls[variantId] === 'string' ? this.#variantUrls[variantId] : '';
    const url = variantUrl || this.#productUrl;

    if (url) {
      link.href = url;
      this.hidden = false;
    } else {
      link.removeAttribute('href');
      this.hidden = true;
    }
  }
}

if (!customElements.get('gp-amazon-cta')) {
  customElements.define('gp-amazon-cta', GPAmazonCTA);
}
